import type { ReactElement } from 'react';

import { I, type IconProps } from '@/components/ri/icons';
import type { PortalRole } from '@/auth/roleAccess';

export type AdminRouteMeta = 'integrations' | 'webhooks' | 'audit-log';

export interface AdminRoute {
  k: string;
  label: string;
  path: string;
  icon: ReactElement<IconProps>;
  allowedRoles: PortalRole[];
  meta?: AdminRouteMeta;
}

export const ADMIN_ROUTES: AdminRoute[] = [
  { k: 'users', label: 'Users', path: '/admin/users', icon: I.users as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'rules', label: 'Rules', path: '/admin/rules', icon: I.flag as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'audit-log', label: 'Audit log', path: '/admin/audit-log', icon: I.clock as ReactElement<IconProps>, allowedRoles: ['Admin'], meta: 'audit-log' },
  { k: 'catalog', label: 'Catalog', path: '/admin/catalog', icon: I.inbox as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'integrations', label: 'Integrations', path: '/admin/integrations', icon: I.bolt as ReactElement<IconProps>, allowedRoles: ['Admin'], meta: 'integrations' },
  { k: 'webhooks', label: 'Webhooks', path: '/admin/webhooks', icon: I.send as ReactElement<IconProps>, allowedRoles: ['Admin'], meta: 'webhooks' },
  { k: 'hubspot', label: 'HubSpot', path: '/admin/hubspot', icon: I.link as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'ambiguous', label: 'Ambiguous accounts', path: '/admin/accounts/ambiguous', icon: I.alert as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'email-templates', label: 'Email templates', path: '/admin/email-templates', icon: I.mail as ReactElement<IconProps>, allowedRoles: ['Admin'] },
  { k: 'diagnostics', label: 'Diagnostics', path: '/admin/diagnostics', icon: I.flash as ReactElement<IconProps>, allowedRoles: ['Admin'] },
];

export function getVisibleAdminRoutes(
  user: { role?: PortalRole | null; isBootstrapAdmin?: boolean } | null | undefined,
): AdminRoute[] {
  return ADMIN_ROUTES.filter(
    (route) =>
      (route.k !== 'diagnostics' || user?.isBootstrapAdmin === true) &&
      user?.role != null && route.allowedRoles.includes(user.role),
  );
}
